import { Icon } from "icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "ui";

import { useWorkoutItemActionsHandler } from "src/workouts/WorkoutItemActionsContext";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export function WorkoutItemActions() {
  const workoutItemsPermissions = useWorkoutPermissions();
  const { t } = useTranslation();

  const handler = useWorkoutItemActionsHandler();

  const [isOpen, setIsOpen] = useState(false);

  if (!workoutItemsPermissions.canEditItems) {
    return null;
  }

  return (
    <DropdownMenu onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant={"ghost"}
          className={cn(
            "p-0 rounded-[4px] h-7 w-7 group-hover:opacity-100 opacity-0",
            { "opacity-100": isOpen },
          )}
        >
          <Icon name="tabler-dots" className={"h-4 w-4"} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[170px]">
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={handler.duplicate}>
            {t("editWorkout.workoutItemActions.duplicate")}
          </DropdownMenuItem>
          {handler.saveAsSection ? (
            <>
              <DropdownMenuItem onClick={handler.saveAsSection}>
                {t("editWorkout.workoutItemActions.saveAsSection")}
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          ) : null}
          {handler.canUnlink && handler.unlink ? (
            <>
              <DropdownMenuItem onClick={handler.unlink}>
                {t("editWorkout.workoutItemActions.unlink")}
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          ) : null}
          <DropdownMenuItem onClick={handler.delete}>
            {t("editWorkout.workoutItemActions.delete")}
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
